<template>
    <div>
         <!-- add expenses -->
         <modal :show.sync="addExpense" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar gasto</h6>
                <div class="form-group">
                    <label>Gasto *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre del gasto"
                                placeholder="nombre del gasto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre del gasto')"
                                v-model="expenseName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="2" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="expenseValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelAddExpense()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="addExpenseToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!--./add expenses-->
        <!-- add expenses -->
        <modal :show.sync="editExpense" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar gasto</h6>
                <div class="form-group">
                    <label>Gasto *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre del gasto"
                                placeholder="nombre del gasto"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre del gasto')"
                                v-model="expenseName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 tabindex="2" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="expenseValue"></vue-numeric>
                </div>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelEditExpense()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="editExpenseToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <!--./add expenses-->
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <!-- Salaries -->
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Gastos por salarios</h6>
            </div>
            <div class="card-body">
                <el-table v-if="actualSalaries.length" :data="actualSalaries"  ref="salariesTable"  @row-dblclick="showEditSalariesMethod" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <div>
                                <p><strong>Cargo:</strong> {{ props.row.salaryPositionName }}</p>
                                <p><strong>Número de Empleados:</strong> {{ props.row.salaryEmployeesNumber }}</p>
                                <p><strong>Salario Básico:</strong> {{ setFormat(props.row.salaryBasic) }}</p>
                                <p><strong>Seguridad Social:</strong> {{ props.row.salarySocialSecurity }}</p>
                                <p><strong>Prestaciones:</strong> {{ props.row.salaryBenefits }}</p>
                                <p v-if="props.row.salaryBenefits == 'Si'"><strong>Cesantías:</strong> {{ setFormat(props.row.salaryLayoffs) }}</p>
                                <p v-if="props.row.salaryBenefits == 'Si'"><strong>Intereses de Cesantías:</strong> {{ setFormat(props.row.salaryInterestLayoffs) }}</p>
                                <p v-if="props.row.salaryBenefits == 'Si'"><strong>Prima:</strong> {{ setFormat(props.row.salaryExtraPayment) }}</p>
                                <p v-if="props.row.salaryBenefits == 'Si'"><strong>Total Prestaciones mes:</strong> {{ setFormat(props.row.salaryTotalBenefits) }}</p>
                                <p v-if="props.row.salaryBenefits == 'Si'"><strong>Total Prestaciones año:</strong> {{ setFormat(props.row.salaryTotalBenefitsAnnual) }}</p>
                                <p><strong>Total Salario:</strong> {{ setFormat(props.row.salaryTotal) }}</p>
                                <p v-if="props.row.salarySocialSecurity == 'Si'"><strong>Gastos:</strong></p>
                                <ul v-if="props.row.salarySocialSecurity == 'Si'">
                                    <li v-for="expense in props.row.expenses" :key="expense.name">
                                        {{ expense.name }}: {{ setFormat(expense.value) }}
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Cargo" property="salaryPositionName"></el-table-column>
                    <el-table-column label="Valor">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.salaryTotal)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div>
                    <p-button 
                        @click="addSalaryMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar salario
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editSalaryMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar salario
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="removeSalaryMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar salario
                    </p-button>
                </div>
                <div v-if="salariesTotalComputed != 0" class="alert alert-success mt-2">
                    <span>Salarios mensuales: {{setFormat(salariesTotalComputed)}}</span>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button v-if="salariesTotalComputed != 0" @click="saveSalaries()" type="warning">Siguiente</p-button>
                    <p-button @click="toMenu()" type="default" class="pull-left mb-3">Atrás</p-button>
                </div>
            </div>
        </card>
        <!-- Add salary -->
        <card v-if="addSalary" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Agregar salario</h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Cargo *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre del cargo"
                                placeholder="nombre del cargo"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre del cargo')"
                                v-model="salaryPositionName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Número de empleados *</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="número de empleados"
                                placeholder="número de empleados"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('número de empleados')"
                                v-model="salaryEmployeesNumber">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Básico *</label>
                    <vue-numeric  :max=999999999999999 tabindex="3" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="salaryBasic"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Seguridad Social *</label>
                    <fg-input   name="seguridad social"
                                tabindex="4"
                                v-validate="modelValidations.item_name"
                                :error="getError('seguridad social')"
                                v-model="salarySocialSecurity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="salarySocialSecurity">
                            <el-option 
                                    class="select-warning"
                                    value="Si"
                                    label="Si">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="No"
                                    label="No">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div>
                    <el-table v-if="actualExpenses.length" :data="actualExpenses"  ref="expensesTable"  @row-dblclick="showEditExpensesMethod" highlight-current-row @current-change="handleExpenseCurrentChange">
                        <el-table-column label="Gasto" property="name"></el-table-column>
                        <el-table-column label="Valor">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.value)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    
                    <div>
                        <p-button 
                            @click="addExpenseMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-plus"></i>Agregar gasto
                        </p-button>
                        <br>
                        <p-button v-if="currentExpenseRow && !currentExpenseRow.lock"
                            @click="editExpenseMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-pencil"></i>Editar gasto
                        </p-button>
                        <br>
                        <p-button v-if="currentExpenseRow && currentExpenseRow.lock == false && currentExpenseRow.name != 'Aux Transporte'"
                            @click="removeExpenseMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-minus"></i>Quitar gasto
                        </p-button>
                    </div>
                </div>
                <div v-if="salaryMonthlyComputed != 0" class="alert alert-success">
                    <span>Total Salario Mes {{setFormat(salaryMonthlyComputed)}}</span>
                </div>
                <div class="form-group">
                    <label>Prestaciones *</label>
                    <fg-input   name="prestaciones"
                                tabindex="4"
                                v-validate="modelValidations.item_name"
                                :error="getError('prestaciones')"
                                v-model="salaryBenefits">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="salaryBenefits">
                            <el-option 
                                    class="select-warning"
                                    value="Si"
                                    label="Si">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="No"
                                    label="No">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="salaryBenefits == 'Si'" class="row">
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.layoffs">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch> 
                        <label class="ml-2">Cesantías</label>
                    </div>
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.layoffsInterest">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch> 
                        <label class="ml-2">Interés cesantías</label>
                    </div>
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.extraPayment">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch> 
                        <label class="ml-2">Prima</label>
                    </div>
            </div>
            <br>
            <div v-if="salaryLayoffs != 0" class="alert alert-warning">
                <span>Cesantías: {{setFormat(salaryLayoffs)}}</span>
            </div>
            <div v-if="salaryInterestLayoffs != 0" class="alert alert-warning">
                <span>Intereses de cesantías {{setFormat(salaryInterestLayoffs)}}</span>
            </div>
            <div v-if="salaryExtraPayment != 0" class="alert alert-warning">
                <span>Prima {{setFormat(salaryExtraPayment)}}</span>
            </div>
            <div v-if="salaryBenefitsComputed != 0" class="alert alert-success">
                <span>Total Prestaciones Mes {{setFormat(salaryBenefitsComputed)}}</span>
            </div>
            <div v-if="salaryTotalComputed != 0" class="alert alert-success">
                <span><strong>TOTAL SALARIO {{setFormat(salaryTotalComputed)}}</strong></span>
            </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button v-if="salaryTotalComputed != 0 && salaryPositionName != '' && salaryEmployeesNumber != null && salaryEmployeesNumber != '' && salarySocialSecurity != '' && salaryBenefits != ''" @click="addSalariesToList()" type="warning">Guardar</p-button>
                    <p-button @click="cancelAddSalary()" type="default" class="pull-left mb-3">Cancelar</p-button>
                </div>
            </div>
        </card>
        <!-- / add salary -->
        <!-- edit salary -->
        <card v-if="editSalary" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Editar salario</h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Cargo *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre del cargo"
                                placeholder="nombre del cargo"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('nombre del cargo')"
                                v-model="salaryPositionName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Número de empleados *</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="número de empleados"
                                placeholder="número de empleados"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('número de empleados')"
                                v-model="salaryEmployeesNumber">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Básico *</label>
                    <vue-numeric  :max=999999999999999 tabindex="3" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="salaryBasic"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Seguridad Social *</label>
                    <fg-input   name="seguridad social"
                                tabindex="4"
                                v-validate="modelValidations.item_name"
                                :error="getError('seguridad social')"
                                v-model="salarySocialSecurity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="salarySocialSecurity">
                            <el-option 
                                    class="select-warning"
                                    value="Si"
                                    label="Si">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="No"
                                    label="No">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div>
                    <el-table v-if="actualExpenses.length" :data="actualExpenses"  ref="expensesTable"  @row-dblclick="showEditExpensesMethod" highlight-current-row @current-change="handleExpenseCurrentChange">
                        <el-table-column label="Gasto" property="name"></el-table-column>
                        <el-table-column label="Valor">
                            <template slot-scope="scope">
                                <span >{{ setFormat(scope.row.value)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    
                    <div>
                        <p-button 
                            @click="addExpenseMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-plus"></i>Agregar gasto
                        </p-button>
                        <br>
                        <p-button v-if="currentExpenseRow && !currentExpenseRow.lock"
                            @click="editExpenseMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-pencil"></i>Editar gasto
                        </p-button>
                        <br>
                        <p-button v-if="currentExpenseRow && currentExpenseRow.lock == false && currentExpenseRow.name != 'Aux Transporte'"
                            @click="removeExpenseMethod()"
                            type="default" 
                            >
                            <i class="mr-2 fa fa-minus"></i>Quitar gasto
                        </p-button>
                    </div>
                </div>
                <div v-if="salaryMonthlyComputed != 0" class="alert alert-success">
                    <span>Total Salario Mes {{setFormat(salaryMonthlyComputed)}}</span>
                </div>
                <div class="form-group">
                    <label>Prestaciones *</label>
                    <fg-input   name="prestaciones"
                                tabindex="4"
                                v-validate="modelValidations.item_name"
                                :error="getError('prestaciones')"
                                v-model="salaryBenefits">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="salaryBenefits">
                            <el-option 
                                    class="select-warning"
                                    value="Si"
                                    label="Si">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="No"
                                    label="No">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="salaryBenefits == 'Si'" class="row">
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.layoffs">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch> 
                        <label class="ml-2">Cesantías</label>
                    </div>
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.layoffsInterest">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch> 
                        <label class="ml-2">Interés cesantías</label>
                    </div>
                    <div class="col-md-12">
                        <p-switch type="warning" v-model="switches.extraPayment">
                            <i class="fa fa-check" slot="on"></i>
                            <i class="fa fa-times" slot="off"></i>
                        </p-switch> 
                        <label class="ml-2">Prima</label>
                    </div>
            </div>
            <br>
            <div v-if="salaryLayoffs != 0" class="alert alert-warning">
                <span>Cesantías: {{setFormat(salaryLayoffs)}}</span>
            </div>
            <div v-if="salaryInterestLayoffs != 0" class="alert alert-warning">
                <span>Intereses de cesantías {{setFormat(salaryInterestLayoffs)}}</span>
            </div>
            <div v-if="salaryExtraPayment != 0" class="alert alert-warning">
                <span>Prima {{setFormat(salaryExtraPayment)}}</span>
            </div>
            <div v-if="salaryBenefitsComputed != 0" class="alert alert-success">
                <span>Total Prestaciones Mes {{setFormat(salaryBenefitsComputed)}}</span>
            </div>
            <div v-if="salaryTotalComputed != 0" class="alert alert-success">
                <span><strong>TOTAL SALARIO {{setFormat(salaryTotalComputed)}}</strong></span>
            </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button v-if="salaryTotalComputed != 0 && salaryPositionName != '' && salaryEmployeesNumber != null && salaryEmployeesNumber != '' && salarySocialSecurity != '' && salaryBenefits != ''" @click="editSalariesToList()" type="warning">Guardar</p-button>
                    <p-button @click="cancelEditSalary()" type="default" class="pull-left mb-3">Cancelar</p-button>
                </div>
            </div>
        </card>
        <!-- / edit salary -->
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn} from 'element-ui'
    import Expenses from 'src/util/Services/Expenses'
    import Travels from 'src/util/Services/Travels'
    import Taxes from 'src/util/Services/Taxes'
    import moment from 'moment'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            health: null,
            pension: null,
            arl: null,
            compensation: null,
            severancePayInterest: null,
            form: {
                average_selection: '',
            },
            alertFlag: true,
            periodicity: '',
            periodicityFlag: true,
            periodicityDaysFlag: true,
            periodicity_days: 0,
            vehicles : [],
            travels : [],
            expenses : [],
            taxes: [],
            actualSalaries: [],
            actualVehicles: [],
            actualTravels: [],
            actualExpenses: [
                {
                    name: "Aux Transporte",
                    parameter: null,
                    value: 0,
                    lock: false
                }
            ],
            actualTaxes: [],
            currentRow: null,
            currentTaxRow: null,
            currentTravelRow: null,
            currentExpenseRow: null,
            addExpense: false,
            editExpense: false,
            addSalary: false,
            editSalary: false,
            addTravel: false,
            editTravel: false,
            addTax: false,
            editTax: false,
            addSalaryIndex: null,
            monthlyNumber: '',
            salaryPositionName: '',
            salaryEmployeesNumber: '',
            salaryBasic: '',
            salarySocialSecurity: 'No',
            salaryBenefits: '',
            salaryLayoffs: 0,
            salaryInterestLayoffs: 0,
            salaryExtraPayment: 0,
            salaryMonthly: 0,
            salaryTotalBenefits: 0,
            salaryTotalBenefitsAnnual: 0,
            salaryTotal: 0,
            vehicleName: '',
            vehicleValue: '',
            vehicleLocked: false,
            expenseName: '',
            expenseValue: '',
            expenseLocked: false,
            travelName: '',
            travelValue: '',
            travelLocked: false,
            taxName: '',
            taxValue: '',
            taxPeriodicity: '',
            taxLocked: false,
            products: [
                
            ],
            switches: {
                layoffs: false,
                layoffsInterest: false,
                extraPayment: false
            },
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                sales: {
                    required: false
                },
                product_name: {
                    required: false,
                    max: 32
                },
                item_costs: {
                    required: true,
                    min: 1,
                    max: 28
                },
                average_selection: {
                    required: false
                },
                item_name: {
                    required: false,
                    max: 32
                },
            },
        }
        },
        watch: {
            salarySocialSecurity: function(newVal){
                const oldExpenses = this.actualExpenses;
                const auxTransporte = oldExpenses.find(expense => expense.name === "Aux Transporte");
                if(newVal == 'Si'){ 
                    this.actualExpenses = [
                        {
                            name: "Aux Transporte",
                            parameter: null,
                            value: auxTransporte.value,
                            lock: false
                        },
                        {
                            name: `Salud(${this['health']}%)`,
                            parameter: "health",
                            value: 0,
                            lock: true
                        },
                        {
                            name: `Pensión(${this['pension']}%)`,
                            parameter: "pension",
                            value: 0,
                            lock: true
                        },
                        {
                            name: `ARL(${this['arl']}%)`,
                            parameter: "arl",
                            value: 0,
                            lock: true
                        },
                        {
                            name: `Caja Comp.(${this['compensation']}%)`,
                            parameter: "compensation",
                            value: 0,
                            lock: true
                        }
                    ]
                }else {
                    this.actualExpenses = [
                        {
                            name: "Aux Transporte",
                            parameter: null,
                            value: auxTransporte.value,
                            lock: false
                        }
                    ]
                }
                this.actualExpenses.forEach(expense => {
                    if (expense.parameter && this[expense.parameter]) {
                        // Multiplicamos salaryBasic por el porcentaje de la variable correspondiente
                        let calculatedValue = (this.salaryBasic * this[expense.parameter]) / 100;
                        // Limitar a dos decimales
                        expense.value = parseFloat(calculatedValue.toFixed(2));
                    }
                });
            },
            /**
             * This function updates actualExpenses by multiplying salaryBasic
             * by the corresponding percentage and limits the result to two decimals.
             * @param {number} newVal The new value of salaryBasic
             * @param {number} oldVal The previous value of salaryBasic
             */
            salaryBasic: function(newVal, oldVal) {
                this.actualExpenses.forEach(expense => {
                    if (expense.parameter && this[expense.parameter]) {
                        // Multiplicamos salaryBasic por el porcentaje de la variable correspondiente
                        let calculatedValue = (newVal * this[expense.parameter]) / 100;
                        // Limitar a dos decimales
                        expense.value = parseFloat(calculatedValue.toFixed(2));
                    }
                });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            periodicity_days: function(newVal, oldVal) {
                if(newVal < 0) {
                    this.periodicity_days = 1;
                }
                else if(newVal > 7) {
                    this.periodicity_days = 7;
                }
                else if(newVal == '') {
                    this.periodicity_days = 0;
                }
                else {
                    this.periodicity_days = parseFloat(newVal)
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            periodicity: function(newVal, oldVal) {
                
                if (oldVal != '') {
                    this.periodicity_days = 0;
                }
            }
        },
        computed: {
            salariesTotalComputed() {
                // Verificar que actualSalaries esté definido y sea un array
                if (this.actualSalaries && Array.isArray(this.actualSalaries)) {
                    // Sumar todos los salaryTotal
                    return this.actualSalaries.reduce((total, salary) => {
                        return total + (salary.salaryTotal || 0); // Asegurarse de que salaryTotal esté definido
                    }, 0);
                }
                return 0; // Retornar 0 si no hay salarios
            },
            salaryTotalComputed(){
                const benefits = parseFloat(this.salaryBenefitsComputed) || 0; // Parsear y manejar NaN
                const monthly = parseFloat(this.salaryMonthlyComputed) || 0; // Parsear y manejar NaN
                const total = benefits + monthly;
                this.salaryTotal = parseFloat(total.toFixed(2)); // Limitar a dos decimales y guardar en salaryTotal
                return this.salaryTotal;
            },
            salaryBenefitsComputed() {
                // Inicializamos variables
                let cesantias = 0;
                let cesantiasInterest = 0;
                let prima = 0;

                // Comprobamos si salaryBenefits es 'Si'
                if (this.salaryBenefits === 'Si') {
                    // Obtenemos el valor de Aux Transporte en actualExpenses
                    const auxTransporteExpense = this.actualExpenses.find(expense => expense.name === 'Aux Transporte');
                    const auxTransporte = auxTransporteExpense ? auxTransporteExpense.value : 0;

                    // Calculamos las cesantías si el switch está activado
                    if (this.switches.layoffs) {
                        cesantias = (this.salaryBasic + auxTransporte) * (8.33333 / 100); // 8.33333% del salario básico más aux transporte
                        cesantias = parseFloat(cesantias.toFixed(2)); // Limitar a dos decimales
                        this.salaryLayoffs = (cesantias * parseFloat(this.salaryEmployeesNumber) || 0); // Guardamos en salaryLayoffs
                    } else {
                        this.salaryLayoffs = 0; // Resetear si el switch está desactivado
                    }

                    // Calculamos los intereses de las cesantías si el switch está activado
                    if (this.switches.layoffsInterest) {
                        cesantiasInterest = cesantias * (1 / 100); // 1% de las cesantías
                        cesantiasInterest = parseFloat(cesantiasInterest.toFixed(2)); // Limitar a dos decimales
                        this.salaryInterestLayoffs = (cesantiasInterest * parseFloat(this.salaryEmployeesNumber) || 0); // Guardamos en salaryInterestLayoffs
                    } else {
                        this.salaryInterestLayoffs = 0; // Resetear si el switch está desactivado
                    }

                    // Calculamos la prima si el switch está activado
                    if (this.switches.extraPayment) {
                        prima = (this.salaryBasic + auxTransporte) * (8.33333 / 100); // 8.33333% del salario básico más aux transporte
                        prima = parseFloat(prima.toFixed(2)); // Limitar a dos decimales
                        this.salaryExtraPayment = (prima * parseFloat(this.salaryEmployeesNumber) || 0); // Guardamos en salaryExtraPayment
                    } else {
                        this.salaryExtraPayment = 0; // Resetear si el switch está desactivado
                    }
                } else {
                    // Si salaryBenefits no es 'Si', resetear todas las variables
                    this.salaryLayoffs = 0;
                    this.salaryInterestLayoffs = 0;
                    this.salaryExtraPayment = 0;
                }

                // Calculamos el total de beneficios sumando cesantías, intereses y prima
                const totalBenefits = this.salaryLayoffs + this.salaryInterestLayoffs + this.salaryExtraPayment;
                this.salaryTotalBenefits = parseFloat(totalBenefits.toFixed(2)); // Limitar a dos decimales y guardar en salaryTotalBenefits
                this.salaryTotalBenefitsAnnual = (Math.round(this.salaryTotalBenefits) * 12);

                // Retornar el total de beneficios calculado
                return this.salaryTotalBenefits;
            },

            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             salaryMonthlyComputed() {
                // Inicializamos la suma de gastos
                let expensesSum = 0;
                expensesSum = this.actualExpenses.reduce((sum, expense) => {
                    return sum + expense.value;
                }, 0);
                // Guardamos el resultado en la variable salaryMonthly
                this.salaryMonthly = (this.salaryBasic + expensesSum) * parseFloat(this.salaryEmployeesNumber);

                // Retornamos el resultado por si quieres usarlo directamente en algún lugar
                return this.salaryMonthly || 0;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productCostUnity;
                this.productCostTotal = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            // allVehiclesMonthlyCostComputed() {
            //     var sum = 0;
            //     if (this.monthlyNumber != '') {
            //         for (let i=0;i<this.actualVehicles.length;i++) {
            //             sum = sum + (this.actualVehicles[i].value * parseFloat(this.monthlyNumber));
            //         }
            //         this.alertFlag = true;
            //     }
            //     else {
            //         for (let i=0;i<this.actualVehicles.length;i++) {
            //             sum = sum + (this.actualVehicles[i].value);
            //         }
            //         if (sum != 0) {
            //             this.alertFlag = false;
            //         }
            //     }
            //     return sum   
            // },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             allTravelsMonthlyCostComputed() {
                var sum = 0;
                var flag = 0;
                if (this.periodicity == 'Diaria') {
                    this.periodicityDaysFlag = true;
                    if(this.periodicity_days != 0) {
                        flag = parseInt(this.periodicity_days)* 4;
                    }
                    else {
                        this.periodicityDaysFlag = false;
                    }
                }
                else if (this.periodicity == 'Semanal') {
                    flag = 4;
                }
                else if (this.periodicity == 'Mensual') {
                    flag = 1;
                }
                this.periodicityFlag = true;
                for (let i=0;i<this.actualTravels.length;i++) {
                    if (this.actualTravels[i].locked) {
                        if (flag == 0 && this.actualTravels[i].value != 0) {
                                this.periodicityFlag = false;
                        }
                        sum = sum + ((this.actualTravels[i].value)* flag);
                    }
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             allExpensesMonthlyCostComputed() {
                var sum = 0;
                var flag = 0;
                if (this.periodicity == 'Diaria') {
                    this.periodicityDaysFlag = true;
                    if(this.periodicity_days != 0) {
                        flag = parseInt(this.periodicity_days)* 4;
                    }
                    else {
                        this.periodicityDaysFlag = false;
                    }
                }
                else if (this.periodicity == 'Semanal') {
                    flag = 4;
                }
                else if (this.periodicity == 'Mensual') {
                    flag = 1;
                }
                this.periodicityFlag = true;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    if (this.actualExpenses[i].locked) {
                        if (flag == 0 && this.actualExpenses[i].value != 0) {
                                this.periodicityFlag = false;
                        }
                        sum = sum + ((this.actualExpenses[i].value)* flag);
                    }
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allVehiclesMonthlyCostComputed() {
                var sum = 0;
                var flag = 0;
                if (this.periodicity == 'Diaria') {
                    this.periodicityDaysFlag = true;
                    if(this.periodicity_days != 0) {
                        flag = parseInt(this.periodicity_days)* 4;
                    }
                    else {
                        this.periodicityDaysFlag = false;
                    }
                }
                else if (this.periodicity == 'Semanal') {
                    flag = 4;
                }
                else if (this.periodicity == 'Mensual') {
                    flag = 1;
                }
                this.periodicityFlag = true;
                for (let i=0;i<this.actualVehicles.length;i++) {
                    if (this.actualVehicles[i].locked) {
                        if (flag == 0 && this.actualVehicles[i].value != 0) {
                                this.periodicityFlag = false;
                        }
                        sum = sum + ((this.actualVehicles[i].value)* flag);
                    }
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allTaxesMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.actualTaxes.length;i++) {
                    if (this.actualTaxes[i].periodicity == 'Mensual') {
                        sum = sum + this.actualTaxes[i].value;
                    }
                    else {
                        sum = sum + (this.actualTaxes[i].value/ 12);
                    }
                    
                }
                return sum 
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allVehiclesMonthlyCostComputed + this.allTaxesMonthlyCostComputed
            }
        },
        methods: {
            removeSalaryMethod (index) {
                // Verifica que currentRow esté definido
                if (this.currentRow) {
                    // Encuentra el índice del salario en actualSalaries
                    const index = this.actualSalaries.indexOf(this.currentRow);
                    
                    // Si el índice es válido, elimina el elemento
                    if (index !== -1) {
                        this.actualSalaries.splice(index, 1);
                    }
                }
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelEditSalary () {
                this.editSalary = false;
                this.resetSalary();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddSalary () {
                this.addSalary = false;
                this.resetSalary();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showEditSalariesMethod (row) {
                
                this.editSalary = true;
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             showEditExpensesMethod (row) {
                if(!row.lock) {
                    this.expenseName= row.name;
                    this.expenseValue= row.value;
                    this.expenseLocked = row.locked;
                    this.editExpense = true;    
                }
                else {
                    this.showNotificationError("Este gasto no se puede editar");
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             handleTravelCurrentChange(currentRow, oldCurrentRow) {
                this.currentTravelRow = currentRow;
            },
             /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             handleExpenseCurrentChange(currentRow, oldCurrentRow) {
                this.currentExpenseRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleTaxCurrentChange(currentRow, oldCurrentRow) {
                this.currentTaxRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.itemName == '' || this.itemPercent == 0) {
                            this.showNotificationError('El campo nombre de ítem y porcentaje no pueden estar vacíos');
                        }
                        else {
                            this.products[this.addProductIndex].items.push({
                                itemName: this.itemName,
                                itemPurchasePrice: this.itemPurchasePrice,
                                itemSalePrice: this.itemSalePrice,
                                itemPercent: this.itemPercent
                            })
                            this.resetItem();
                            this.addProduct = false;
                            this.addProductIndex = null;
                            this.showNotificationSuccess('Ítem agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editSalaryToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.vehicleName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            var index = this.actualVehicles.indexOf(this.currentRow);
                            this.actualVehicles[index].name = this.vehicleName;
                            this.actualVehicles[index].value = this.vehicleValue;
                            this.resetVehicle();
                            this.currentRow = null;
                            this.$refs.vehiclesTable.setCurrentRow();
                            this.editSalary = false;
                            this.showNotificationSuccess('Vehículo editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editExpenseToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.expenseName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            var index = this.actualExpenses.indexOf(this.currentExpenseRow);
                            this.actualExpenses[index].name = this.expenseName;
                            this.actualExpenses[index].value = this.expenseValue;
                            this.resetVehicle();
                            this.currentExpenseRow = null;
                            this.$refs.expensesTable.setCurrentRow();
                            this.editExpense = false;
                            this.showNotificationSuccess('Gasto editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editTaxToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.taxName == '') {
                            this.showNotificationError('El campo nombre de impuesto no puede estar vacío');
                        }
                        else {
                            var index = this.actualTaxes.indexOf(this.currentTaxRow);
                            this.actualTaxes[index].name = this.taxName;
                            this.actualTaxes[index].value = this.taxValue;
                            this.actualTaxes[index].periodicity = this.taxPeriodicity;
                            this.resetTax();
                            this.currentTaxRow = null;
                            this.$refs.taxesTable.setCurrentRow();
                            this.editTax = false;
                            this.showNotificationSuccess('Impuesto editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addSalaryMethod (row) {
                // this.addProductIndex = row;
                this.resetVehicle();
                this.addSalary = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.resetExpense();
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addTravelMethod (row) {
                // this.addProductIndex = row;
                this.resetTravel();
                this.addTravel = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addTaxMethod (row) {
                // this.addProductIndex = row;
                this.resetTax();
                this.addTax = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addSalaryToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.vehicleName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            var id = this.actualVehicles.length + 1;
                            this.actualVehicles.push({
                                id: id,
                                name: this.vehicleName,
                                value: this.vehicleValue,
                                locked: false
                            })
                            this.resetVehicle();
                            this.addSalary = false;
                            this.showNotificationSuccess('Vehículo agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addExpenseToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.expenseName == '' || this.expenseValue == '' || this.expenseValue == 0) {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            this.actualExpenses.push({
                                name: this.expenseName,
                                value: this.expenseValue,
                                lock: false
                            })
                            this.resetExpense();
                            this.addExpense = false;
                            this.showNotificationSuccess('Gasto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addTravelToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.travelName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            var id = this.actualTravels.length + 1;
                            this.actualTravels.push({
                                id: id,
                                name: this.travelName,
                                value: this.travelValue,
                                locked: false
                            })
                            this.resetTravel();
                            this.addTravel = false;
                            this.showNotificationSuccess('Gasto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addTaxToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.taxName == '') {
                            this.showNotificationError('El campo nombre de impuesto no puede estar vacío');
                        }
                        else {
                            var id = this.actualTaxes.length + 1;
                            this.actualTaxes.push({
                                id: id,
                                name: this.taxName,
                                periodicity: this.taxPeriodicity,
                                value: this.taxValue,
                                locked: false
                            })
                            this.resetTax();
                            this.addTax = false;
                            this.showNotificationSuccess('Impuesto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetSalary () {
                this.salaryPositionName= '';
                this.salaryEmployeesNumber= '';
                this.salaryBasic= '';
                this.salarySocialSecurity= '';
                this.salaryBenefits= '';
                this.salaryLayoffs= 0;
                this.salaryInterestLayoffs= 0;
                this.salaryExtraPayment= 0;
                this.salaryMonthly= 0;
                this.salaryTotalBenefits= 0;
                this.salaryTotalBenefitsAnnual = 0;
                this.salaryTotal= 0;
                this.switches= {
                    layoffs: false,
                    layoffsInterest: false,
                    extraPayment: false
                },
                this.actualExpenses= [
                {
                    name: "Aux Transporte",
                    parameter: null,
                    value: 0,
                    lock: false
                },
                {
                    name: "Salud",
                    parameter: "health",
                    value: 0,
                    lock: true
                },
                {
                    name: "Pensión",
                    parameter: "pension",
                    value: 0,
                    lock: true
                },
                {
                    name: "ARL",
                    parameter: "arl",
                    value: 0,
                    lock: true
                },
                {
                    name: "Caja Comp.",
                    parameter: "compensation",
                    value: 0,
                    lock: true
                }
            ];
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetVehicle () {
                this.vehicleName = '';
                this.vehicleValue = '';   
                this.vehicleLocked = false;
            },
             /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';   
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             resetTravel () {
                this.travelName = '';
                this.travelValue = '';   
                this.travelLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetTax () {
                this.taxName = '';
                this.taxValue = '';   
                this.taxPeriodicity = 'Anual';   
                this.taxLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editSalaryMethod() {
                this.salaryPositionName = this.currentRow.salaryPositionName;
                this.salaryEmployeesNumber = this.currentRow.salaryEmployeesNumber;
                this.salaryBasic = this.currentRow.salaryBasic;
                this.salarySocialSecurity = this.currentRow.salarySocialSecurity;
                this.salaryBenefits = this.currentRow.salaryBenefits;
                this.salaryLayoffs = this.currentRow.salaryLayoffs;
                this.salaryInterestLayoffs = this.currentRow.salaryInterestLayoffs;
                this.salaryExtraPayment = this.currentRow.salaryExtraPayment;
                this.salaryMonthly = this.currentRow.salaryMonthly;
                this.salaryTotalBenefits = this.currentRow.salaryTotalBenefits;
                this.salaryTotalBenefitsAnnual = this.currentRow.salaryTotalBenefitsAnnual;
                this.salaryTotal = this.currentRow.salaryTotal;
                this.switches = this.currentRow.salarySwitches;
                this.actualExpenses = this.currentRow.expenses.map(expense => ({ ...expense })); // Copia de gastos
                console.log(this.actualExpenses);
                this.editSalary = true; // Activar modo de edición
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editExpenseMethod () {
                this.expenseName= this.currentExpenseRow.name;
                this.expenseValue= this.currentExpenseRow.value;
                this.expenseLocked = this.currentExpenseRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editTravelMethod () {
                this.travelName= this.currentTravelRow.name;
                this.travelValue= this.currentTravelRow.value;
                this.travelLocked = this.currentTravelRow.locked;
                this.editTravel = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editTaxMethod () {
                this.taxName= this.currentTaxRow.name;
                this.taxPeriodicity= this.currentTaxRow.periodicity;
                this.taxValue= this.currentTaxRow.value;
                this.taxLocked = this.currentTaxRow.locked;
                this.editTax = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeVehicleMethod () {
                this.actualVehicles.splice(this.actualVehicles.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentExpenseRow),1);
                this.currentExpenseRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             removeTravelMethod () {
                this.actualTravels.splice(this.actualTravels.indexOf(this.currentTravelRow),1);
                this.currentTravelRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeTaxMethod () {
                this.actualTaxes.splice(this.actualTaxes.indexOf(this.currentTaxRow),1);
                this.currentTaxRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddVehicle () {
                this.addSalary = false;
                this.resetVehicle();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelAddTravel () {
                this.addTravel = false;
                this.resetTravel();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditVehicle () {
                this.editSalary = false;
                this.resetVehicle();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelEditTravel () {
                this.editTravel = false;
                this.resetTravel();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddTax () {
                this.addTax = false;
                this.resetTax();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditTax () {
                this.editTax = false;
                this.resetTax();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toMenu () {
                this.$router.push('/asessments/menu');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addSalariesToList () {
                return new Promise((resolve, reject) => {
                    this.$validator.validateAll().then(isValid => {
                        if (isValid) {
                            // Creamos el objeto actualSalaries
                            const Salaries = {
                                salaryPositionName: this.salaryPositionName,
                                salaryEmployeesNumber: this.salaryEmployeesNumber,
                                salaryBasic: this.salaryBasic,
                                salarySocialSecurity: this.salarySocialSecurity,
                                salaryBenefits: this.salaryBenefits,
                                salaryLayoffs: this.salaryLayoffs,
                                salaryInterestLayoffs: this.salaryInterestLayoffs,
                                salaryExtraPayment: this.salaryExtraPayment,
                                salaryMonthly: this.salaryMonthly,
                                salaryTotalBenefits: this.salaryTotalBenefits,
                                salaryTotalBenefitsAnnual: this.salaryTotalBenefitsAnnual,
                                salaryTotal: this.salaryTotal,
                                salarySwitches: this.switches,
                                expenses: this.actualExpenses.map(expense => ({ ...expense })) // Copia de actualExpenses
                            };

                            // Asegúrate de que actualSalaries esté inicializado
                            if (!this.actualSalaries) {
                                this.actualSalaries = []; // Inicializa la lista si no existe
                            }

                            // Agregamos actualSalaries a la lista
                            this.actualSalaries.push(Salaries);
                            this.addSalary = false;
                            
                            resolve(); // Resolviendo la promesa
                        } else {
                            reject(new Error('Validación fallida')); // Rechazar si la validación falla
                        }
                    }).catch(error => {
                        reject(error); // Manejo de errores en la validación
                    });
                }).then(() => {
                    this.resetSalary(); // Llama al método para resetear campos
                }).catch(error => {
                    console.error(error); // Manejo de errores al agregar salarios
                });
            },
            editSalariesToList() {
                return new Promise((resolve, reject) => {
                    this.$validator.validateAll().then(isValid => {
                        if (isValid) {
                            // Encontrar el índice del currentRow en actualSalaries
                            const index = this.actualSalaries.indexOf(this.currentRow);
                            if (index !== -1) {
                                // Actualizar los campos específicos
                                this.actualSalaries[index].salaryPositionName = this.salaryPositionName;
                                this.actualSalaries[index].salaryEmployeesNumber = this.salaryEmployeesNumber;
                                this.actualSalaries[index].salaryBasic = this.salaryBasic;
                                this.actualSalaries[index].salarySocialSecurity = this.salarySocialSecurity;
                                this.actualSalaries[index].salaryBenefits = this.salaryBenefits;
                                this.actualSalaries[index].salaryLayoffs = this.salaryLayoffs;
                                this.actualSalaries[index].salaryInterestLayoffs = this.salaryInterestLayoffs;
                                this.actualSalaries[index].salaryExtraPayment = this.salaryExtraPayment;
                                this.actualSalaries[index].salaryMonthly = this.salaryMonthly;
                                this.actualSalaries[index].salaryTotalBenefits = this.salaryTotalBenefits;
                                this.actualSalaries[index].salaryTotalBenefitsAnnual = this.salaryTotalBenefitsAnnual;
                                this.actualSalaries[index].salaryTotal = this.salaryTotal;
                                this.actualSalaries[index].salarySwitches = this.switches;
                                this.actualSalaries[index].expenses = this.actualExpenses.map(expense => ({ ...expense }));

                                // Notificación y finalización
                                this.showNotificationSuccess('Salario editado correctamente');
                                resolve(); // Resolver la promesa
                            } else {
                                this.showNotificationError('Salario no encontrado');
                                reject(new Error('Salario no encontrado'));
                            }    
                        } else {
                            reject(new Error('Validación fallida')); // Rechazar si la validación falla
                        }
                    }).catch(error => {
                        reject(error); // Manejo de errores en la validación
                    });
                }).then(() => {
                    // Reseteo de campos solo después de que la promesa se resuelva
                    this.resetSalary(); 
                    this.currentRow = null; 
                    this.$refs.salariesTable.setCurrentRow(); 
                    this.editSalary = false; 
                }).catch(error => {
                    console.error(error); // Manejo de errores al editar salarios
                });
            },

            saveSalaries () {
                if (this.actualSalaries.length != 0) {
                    this.$store.dispatch('setSalaries', this.actualSalaries).then(()=>{
                        var payload = {
                            stage: 'Ingreso de datos de negocio',
                            description: 'Se ingresan '+ this.actualSalaries.length+' salarios del negocio',
                            dateTime: moment().format()
                        };
                        // this.$router.push('/asessments/new_asessment/customer/others/financial-obligations');
                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                            var vm = this;
                            swal({
                                title: '¿Deseas agregar información de Obligaciones Financieras?',
                                // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                text: 'Si aceptas, podrás agregar o editar la información de las Obligaciones Financieras',
                                type: 'info',
                                showCancelButton: true,
                                confirmButtonText: 'Si, aceptar',
                                cancelButtonText: 'No, continuar',
                                confirmButtonClass: 'btn btn-success btn-fill',
                                cancelButtonClass: 'btn btn-danger btn-fill',
                                buttonsStyling: false
                            }).then(() => {
                                vm.$router.push('/asessments/new_asessment/customer/others/financial-obligations');
                            }, function (dismiss) {
                                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                if (dismiss == 'cancel') {
                                    vm.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                                }
                                else {
                                    swal({
                                        title: 'Cancelado',
                                        text: 'El analista no ha continuado',
                                        type: 'error',
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        buttonsStyling: false
                                    })
                                }
                            })
                        });
                        
                    });
                }
                else {
                    this.showNotificationError('Debe ingresar al menos un salario');
                    // this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                }
                
            }
        },
        mounted () {
            this.health = Number((this.$store.state.health)).toFixed(2);
            this.pension =  Number(this.$store.state.pension).toFixed(2);
            this.arl =  Number(this.$store.state.arl).toFixed(3);
            this.compensation =  Number(this.$store.state.compensation).toFixed(2);
            this.severancePayInterest = this.$store.state.severancePayInterest;
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].salaries.length != 0) {
                    this.actualSalaries = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].salaries;
                }
            }
            else if(this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].salaries.length != 0) {
                    this.actualSalaries = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].salaries;
                }
            }
            else if(this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].transportCosts.length != 0) {
                    this.actualSalaries = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].salaries;
                }
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
